import { useReducer, useEffect, useMemo } from 'react';
import { applyTheme, resolvePalette } from '../theme';
import type { Palette, ThemeName } from '../types';

/**
 * Resolves the active color palette and syncs SCSS CSS variables via data-theme.
 */
export function usePalette(theme: ThemeName): Palette {
  const [, bump] = useReducer((n: number) => n + 1, 0);

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => {
      applyTheme(theme);
      bump();
    };
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [theme]);

  return useMemo(() => resolvePalette(theme), [theme, bump]);
}
